import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useThemeContext } from '@utils/hooks/use-theme-context.ts';

type JumpToViewWordProps = {
  visible: 'up' | 'down' | false;
  onJumpToWord: () => void;
  height?: number;
};

export function JumpToViewWord({
  onJumpToWord,
  visible,
  height = 54
}: JumpToViewWordProps) {
  const { t } = useTranslation();
  const { getColour } = useThemeContext();

  return (
    <motion.div
      animate={{ y: visible !== false ? 0 : 200 }}
      initial={{ y: 100 }}
      style={{
        position: 'fixed',
        bottom: height,
        left: 0,
        right: 0,
        zIndex: 999,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
      }}
      onClick={e => {
        e.stopPropagation();
        onJumpToWord();
      }}
    >
      {visible !== false && (
        <div
          className="rounded-xl overflow-hidden shadow-lg cursor-pointer border"
          style={{
            backgroundColor: getColour('thirdLayer'),
            borderColor: getColour('border'),
            color: getColour('normalText')
          }}
        >
          <div className={'flex items-center justify-center gap-2 py-3 px-6'}>
            <div>{t('jump-to-current-word')}...</div>
          </div>
        </div>
      )}
    </motion.div>
  );
}
